import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'
import mediaUrlsResolver from './mediaUrlsResolver'

const isMediaDocResolver: FieldResolver = (metadata: Metadata) => {
  const { mediaUrls } = mediaUrlsResolver(metadata)
  return { isMediaDoc: mediaUrls!.length > 0 } as StreamData
}

export default isMediaDocResolver
